// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host::ng-deep p {
  font-family: AppFont;
  line-height: 1.4;
  margin-bottom: 0px;
  font-size: 14px;
}
:host::ng-deep h2 {
  font-family: AppFontMedium;
  margin: 25px 0 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/impressum/impressum.page.scss"],"names":[],"mappings":"AASE;EACC,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AARH;AAWE;EACC,0BAAA;EACA,kBAAA;AATH","sourcesContent":["// h3,h2,h4 {\n//     color: var(--ion-color-secondary);\n//     font-weight: normal;\n//     font-family: Capture, sans-serif;\n//     font-size: 24px;\n// }\n\n:host {\n\t&::ng-deep {\n\t\tp {\n\t\t\tfont-family: AppFont;\n\t\t\tline-height: 1.4;\n\t\t\tmargin-bottom: 0px;\n\t\t\tfont-size: 14px;\n\t\t}\n\n\t\th2 {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tmargin: 25px 0 8px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
